import { Button, Divider, Row, Typography } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import { ListMarketplaceTable } from '../components/ListMarketplaceTable';

const { Title } = Typography;

export const MarketplaceScreen: FC = () => {
  useBreadcrumbs([
    {
      label: 'Marketplace',
    },
  ]);

  const navigate = useNavigate();

  return (
    <>
      <Row style={{ marginBottom: '24px' }} justify='space-between'>
        <Title level={3}>Marketplace</Title>

        <Button
          type='primary'
          onClick={() => navigate('/marketplace/create-or-update')}
        >
          + Novo Item
        </Button>
      </Row>

      <Divider style={{ marginBottom: '24px' }} />

      <ListMarketplaceTable />
    </>
  );
};
